<template>
  <div :class="classe" class="wbs-page-title">
    <h4>{{ titulo }}</h4>
    <p class="text-muted mb-2">{{ descricao }}</p>
  </div>
</template>
<script>
export default {
  name: "appPaginaTitulo",
  props: {
    titulo: {
      type: String,
      required: true
    },
    descricao: {
      type: String
    },
    classe: {
      type: String
    }
  }
};
</script>
<style lang="scss">
.wbs-page-title {
  padding-top: 0.5rem;
  margin: 0 1rem;

  & h4 {
    font-size: 1.3rem;
    font-weight: 600;
    margin-bottom: 0;
  }
  & p {
    font-size: 0.8rem;
  }
}
</style>
